<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card v-if="isDataLoaded">
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Project preview</span>
              </div>
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="[editedItem.projectData]"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <!-- <template> -->
                    <tr>
                      <td>Project Name</td>
                      <td class="text-xs-left">
                        {{ props.item.name }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project type</td>
                      <td class="text-xs-left">
                        {{ props.item.project_types.name }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project Description</td>
                      <td class="text-xs-left">{{ props.item.details }}</td>
                    </tr>
                    <tr v-if="props.item.has_pre_survey == 1">
                      <td>Pre Survey Description</td>
                      <td class="text-xs-left">
                        {{ props.item.pre_survey_descriptions }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project Language</td>
                      <td class="text-xs-left">
                        {{ getProjectLanguage(props.item.project_language) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Estimated Starting Time</td>
                      <td class="text-xs-left">{{ props.item.begin_date }}</td>
                    </tr>
                    <tr>
                      <td>Estimated Ending Time</td>
                      <td class="text-xs-left">{{ props.item.end_date }}</td>
                    </tr>
                    <tr>
                      <td>Total Budget(Tk)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_amount }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Total Budget(coins)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_coins }}
                      </td>
                    </tr>
                    <tr>
                      <td v-if="props.item.project_status_id >= 8">
                        Per Survey Cost(Coins)
                      </td>
                      <td v-else>Per Survey Cost(Tk)</td>
                      <td class="text-xs-left">
                        {{ props.item.per_survey_cost }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Response</td>
                      <td class="text-xs-left">
                        {{ props.item.number_of_response }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </template>
              <!-- <v-divider></v-divider> -->
            </v-card-text>
            <preview-location
              :projectId="parseInt(data.project_id)"
              v-if="editedItem.projectInfo.project_type_id == 2"
            ></preview-location>
            <!-- //pre-survey question data -->
            <v-card v-if="indexData.projectData.has_pre_survey">
              <v-card-title class="project">
                <div>
                  <span class="headline white--text">Pre Survey Question</span>
                </div>
              </v-card-title>
              <v-card-text>
                <div>
                  <div
                    v-for="(pre_ques, index) in editedItem.preQuestions"
                    v-bind:key="index"
                  >
                    <!-- pre-survey question part -->
                    <br />
                    <div>
                      <span v-if="pre_ques.question == ''" class="red--text">
                        {{ q_validate }} <br />
                      </span>
                      <span>Pre_Q{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.projectData.project_language == 1 ||
                          indexData.projectData.project_language == 3
                        "
                      >
                        <span class="font-weight-bold"
                          >Question Title English:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question }}
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.projectData.project_language == 2 ||
                          indexData.projectData.project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold"
                          >Question Title Bangla:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question_bangla }} <br />
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                    </div>
                    <!-- option and multiple image section -->
                    <div
                      v-if="
                        pre_ques.ui_category_id == 1 ||
                        pre_ques.ui_category_id == 2 ||
                        pre_ques.ui_category_id == 4 ||
                        pre_ques.ui_category_id == 14
                      "
                    >
                      <div v-if="pre_ques.ui_category_id == 14">
                        <span v-for="(option, i) in pre_ques.images" :key="i">
                          <br /><v-img
                            height="150"
                            width="200"
                            :src="indexData.preQuesImageUrl + option.url"
                          ></v-img>
                          <div class="mt-3">
                            {{ i + 1 }} . {{ option.name }}
                          </div>
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 1 &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in pre_ques.radios" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 1 &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in pre_ques.radios_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 2 &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span
                          v-for="(option, i) in pre_ques.checkboxes"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 2 &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in pre_ques.checkboxes_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 4 &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span
                          v-for="(option, i) in pre_ques.dropdowns"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.name }}
                        </span>
                      </div>
                      <div
                        v-if="
                          pre_ques.ui_category_id == 4 &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in pre_ques.dropdowns_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.name }}
                        </span>
                      </div>
                    </div>
                    <!-- instruction and description -->
                    <div>
                      <span
                        v-if="
                          pre_ques.instruction != null &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold"> Instruction: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.instruction"></div>
                      </span>
                      <span
                        v-if="
                          pre_ques.instruction_bangla != null &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold">
                          Instruction Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.instruction_bangla"></div>
                      </span>

                      <span
                        v-if="
                          pre_ques.description != null &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold"> Description: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.description"></div>
                      </span>
                      <span
                        v-if="
                          pre_ques.description_bangla != null &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold">
                          Description Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="pre_ques.description_bangla"></div>
                      </span>
                    </div>
                    <div>
                      <pre-survey-question-logic-preview
                        :pre_question_logic="pre_ques.logic_set"
                        :operators="indexData.operators"
                      />
                    </div>
                    <!-- <br /> -->
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card>
              <v-card-title class="project">
                <div><span class="headline white--text">Question</span></div>
              </v-card-title>
              <v-card-text>
                <div>
                  <span class="font-weight-bold"
                    >Note:Here star mark (<span class="red--text">*</span>) is
                    required.</span
                  >

                  <div
                    v-for="(ques, index) in editedItem.questions"
                    v-bind:key="index"
                  >
                    <!-- question part -->
                    <br />
                    <div>
                      <span v-if="ques.question == ''" class="red--text">
                        {{ q_validate }} <br />
                      </span>
                      <span>Q{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.projectData.project_language == 1 ||
                          indexData.projectData.project_language == 3
                        "
                      >
                        <span class="font-weight-bold"
                          >Question Title English:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ ques.question }}
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.projectData.project_language == 2 ||
                          indexData.projectData.project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold"
                          >Question Title Bangla:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }} <br />
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span>
                        <span class="font-weight-bold">Question Type:</span>
                        &nbsp;&nbsp;&nbsp;{{
                          indexData.uiCategory[ques.ui_category_id - 1].name
                        }}
                        <br />
                      </span>
                      <br />
                    </div>
                    <!-- option and multiple image section -->
                    <div
                      v-if="
                        ques.ui_category_id == 1 ||
                        ques.ui_category_id == 2 ||
                        ques.ui_category_id == 4 ||
                        ques.ui_category_id == 14
                      "
                    >
                      <div v-if="ques.ui_category_id == 14">
                        <span v-for="(option, i) in ques.images" :key="i">
                          <br /><v-img
                            height="150"
                            width="200"
                            :src="indexData.quesImageUrl + option.url"
                          ></v-img>
                          <div class="mt-3"></div>
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 1 &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in ques.options" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 1 &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in ques.options_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 2 &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option English: <br />
                        <span v-for="(option, i) in ques.options" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 2 &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <span
                          v-for="(option, i) in ques.options_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            check_box_outline_blank
                          </v-icon>
                          {{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 4 &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option English: <br />
                        <!-- <v-select
                            :items="ques.options"
                            item-text="title"
                            item-value="value"
                            box
                            label="drop down options"
                          ></v-select> -->
                        <span v-for="(option, i) in ques.options" :key="i">
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.title }}
                        </span>
                      </div>
                      <div
                        v-if="
                          ques.ui_category_id == 4 &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        Option Bangla: <br />
                        <v-select
                          :items="ques.options_bangla"
                          item-text="title"
                          item-value="value"
                          box
                          label="Option Bangla"
                        ></v-select>
                        <span
                          v-for="(option, i) in ques.options_bangla"
                          :key="i"
                        >
                          <br v-if="i > 0" /><v-icon small>
                            radio_button_unchecked </v-icon
                          >{{ option.title }}
                        </span>
                      </div>
                    </div>
                    <!-- instruction and description -->
                    <div>
                      <span
                        v-if="
                          ques.instruction != null &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold"> Instruction: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.instruction"></div>
                      </span>
                      <span
                        v-if="
                          ques.instruction_bangla != null &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold">
                          Instruction Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.instruction_bangla"></div>
                      </span>

                      <span
                        v-if="
                          ques.description != null &&
                          (indexData.projectData.project_language == 1 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold"> Description: </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.description"></div>
                      </span>
                      <span
                        v-if="
                          ques.description_bangla != null &&
                          (indexData.projectData.project_language == 2 ||
                            indexData.projectData.project_language == 3)
                        "
                      >
                        <span class="font-weight-bold">
                          Description Bangla:
                        </span>
                        <br />
                        &nbsp;&nbsp;&nbsp;
                        <div v-html="ques.description_bangla"></div>
                      </span>
                    </div>
                    <!-- date time question -->
                    <div v-if="ques.ui_category_id == 12">
                      <span
                        class="font-weight-bold"
                        v-if="ques.date_time != null"
                      >
                        {{ ques.date_time }}
                      </span>
                    </div>

                    <!-- range slider star rating -->
                    <div
                      v-if="
                        ques.ui_category_id == 6 ||
                        ques.ui_category_id == 7 ||
                        ques.ui_category_id == 8
                      "
                    >
                      <div v-if="ques.ui_category_id == 6">
                        <span
                          class="font-weight-bold"
                          v-if="
                            ques.option_values.min != '' &&
                            ques.option_values.max != ''
                          "
                        >
                          Min value: {{ ques.option_values.min }}<br />
                          Max value: {{ ques.option_values.max }}
                        </span>
                      </div>
                      <div v-if="ques.ui_category_id == 7">
                        <span
                          class="font-weight-bold"
                          v-if="
                            ques.option_values.min_value != '' &&
                            ques.option_values.max_value != ''
                          "
                        >
                          Min value: {{ ques.option_values.min }}<br />
                          Max value: {{ ques.option_values.max }}
                        </span>
                        <span
                          class="font-weight-bold"
                          v-if="ques.option_values.interval != ''"
                        >
                          <br />
                          interval: {{ ques.option_values.interval }}
                        </span>
                      </div>
                    </div>
                    <!-- contact info question type -->
                    <div v-if="ques.ui_category_id == 15">
                      <span v-if="ques.contactInfo.first_name == true">
                        First Name: _________
                      </span>
                      <span v-if="ques.contactInfo.middle_name == true">
                        <br />
                        Middle Name: _________
                      </span>
                      <span v-if="ques.contactInfo.last_name == true">
                        <br />
                        Last Name: _________
                      </span>
                      <span v-if="ques.contactInfo.phone == true">
                        <br />
                        <v-icon small> call </v-icon>Phone: _________
                      </span>
                      <span v-if="ques.contactInfo.email == true">
                        <br />email: _________
                      </span>
                      <span v-if="ques.contactInfo.address == true">
                        <br /><v-icon small> home </v-icon
                        ><span class="font-weight-bold"> Address:</span>
                        <br />Country: _________ <br />Division: _________
                        <br />District : _________ <br />Area: _________
                        <br />Road No: _________ <br />House No: _________
                      </span>
                    </div>
                    <!-- multiple answer  -->
                    <span class="font-weight-bold">Multiple ans:</span>
                    <v-icon small class="mr-1">check_box_outline_blank</v-icon>
                    <span v-if="ques.multiple_answer == 1">yes</span>
                    <span v-else>no</span>
                    <!-- <br /> -->
                    <div v-if="ques.has_logic">
                      <question-logic
                        :question_logic="ques.logic_group"
                        :questions="editedItem.questions"
                        :counter_index="index"
                      />
                    </div>
                    <!-- <pre>{{ ques }}</pre> -->
                    <div v-if="hasValidation(ques)">
                      <question-validating-parameter :question="ques" />
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <v-card v-if="editedItem.projectInfo.project_type_id == 1">
              <v-card-title
                class="project"
                v-if="editedItem.filter_skip == '0'"
              >
                <div>
                  <span class="headline white--text"
                    >Project Filtering Parameters</span
                  >
                </div>
              </v-card-title>
              <v-card-text
                v-if="
                  editedItem.projectInfo.project_type_id == 1 &&
                  editedItem.filter_skip == '0'
                "
              >
                <div>
                  <v-card
                    v-for="(filter_group, index) in editedItem.filter_data"
                    v-bind:key="index"
                  >
                    <v-btn class="fa-pull-right"> Group - {{ index }}</v-btn>
                    <v-card-text
                      row
                      v-for="(
                        add_filtering, counter
                      ) in filter_group.add_filterings"
                      v-bind:key="counter"
                    >
                      <div class="col-md-4">
                        {{
                          ProjectFilterBasicData.ProjectFilteringParameter[
                            add_filtering.filtering_parameter_id - 1
                          ].name
                        }}
                      </div>
                      <div class="col-md-4">
                        {{
                          ProjectFilterBasicData.operators[
                            add_filtering.comparison_operator_id - 1
                          ].name
                        }}
                      </div>
                      <div
                        class="col-md-4"
                        v-if="add_filtering.filtering_parameter_id == 1"
                      >
                        age: {{ add_filtering.age1 }}
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 2"
                      >
                        <span
                          v-for="(
                            gender, gender_index
                          ) in add_filtering.gender_id"
                          :key="gender_index"
                        >
                          {{ ProjectFilterBasicData.genders[gender - 1].name }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 3"
                      >
                        <span
                          v-for="(
                            division, division_index
                          ) in add_filtering.division_id"
                          :key="division_index"
                        >
                          {{
                            ProjectFilterBasicData.divisions[division - 1]
                              .english_title
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 4"
                      >
                        <span
                          v-for="(
                            district, district_index
                          ) in add_filtering.district_id"
                          :key="district_index"
                        >
                          {{
                            ProjectFilterBasicData.districts[district - 1]
                              .english_title
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 5"
                      >
                        <span
                          v-for="(
                            education, education_index
                          ) in add_filtering.education_id"
                          :key="education_index"
                        >
                          {{
                            ProjectFilterBasicData.educations[education - 1]
                              .name
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div
                        class="col-md-4"
                        v-else-if="add_filtering.filtering_parameter_id == 6"
                      >
                        <span
                          v-for="(
                            profession, profession_index
                          ) in add_filtering.profession_id"
                          :key="profession_index"
                        >
                          {{
                            ProjectFilterBasicData.professions[profession - 1]
                              .name
                          }}
                          &nbsp;
                        </span>
                      </div>
                      <div class="col-md-4" v-else>
                        <span
                          v-for="(
                            income, income_index
                          ) in add_filtering.income_id"
                          :key="income_index"
                        >
                          {{ ProjectFilterBasicData.income[income - 1].name }}
                          &nbsp;
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                  <v-card-text>
                    Available Dasher on this filter is:
                    {{ indexData.projectData.available_dasher }}
                  </v-card-text>
                </div>
              </v-card-text>
            </v-card>
            <assigned-agent-group-to-project
              v-if="indexData.projectData.dasher_category_id == 3"
              :project_id="indexData.projectData.id"
            ></assigned-agent-group-to-project>
            <assigned-teams-to-project
              v-if="indexData.projectData.dasher_category_id == 2"
              :project_id="indexData.projectData.id"
            ></assigned-teams-to-project>

            <v-card-actions>
              <v-spacer></v-spacer>
              <button class="button" flat @click="back">Back</button>
              <v-btn
                class="button"
                flat
                @click="submit"
                :disabled="clicked || q_blank_status"
              >
                {{ check_submit }}
              </v-btn>
            </v-card-actions>

            <!-- <v-btn @click="save">submit</v-btn> -->
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import {
  QuestionLogic,
  QuestionValidatingParameter,
  PreSurveyQuestionLogicPreview,
  AssignedAgentGroupToProject,
  AssignedTeamsToProject,
} from "@/components/index";
import PreviewLocation from "./components/PreviewLocation";
import router from "@/router";

export default {
  components: {
    QuestionLogic,
    QuestionValidatingParameter,
    PreSurveyQuestionLogicPreview,
    PreviewLocation,
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
  },
  data: () => ({
    apiUrl: "project-info-details",
    clicked: false,
    q_blank_status: false,
    teams: [],
    sl: 1,

    loading: false,
    editedIndex: -1,
    img_op: null,
    ProjectFilterBasicData: {
      ProjectFilteringParameter: [],
      districts: [],
      divisions: [],
      educations: [],
      genders: [],
      income: [],
      operators: [],
      professions: [],
      upazila: [],
    },
    editedItem: {
      projectData: [
        {
          // project data
          name: "",
          project_type_id: "",
          details: "",
          begin_date: "",
          end_date: "",
          duration: "",
          project_language: "",
          total_budget_amount: 0,
          per_survey_cost: 0,
          number_of_response: 0,
        },
      ],
      projectInfo: {
        // project data
        name: "",
        project_type_id: "",
        details: "",
        begin_date: "",
        end_date: "",
        duration: "",
        project_language: "",
        total_budget_amount: 0,
        per_survey_cost: 0,
        number_of_response: 0,
      },

      questions: [
        {
          question: "",
          question_variable: "var1",
          question_bangla: "",
          ui_category_id: "",
          required_optional: false,
          multiple_answer: false,
          instruction: "",
          instruction_bangla: "",
          description: "",
          description_bangla: "",
          error_message: "",
          boolean1: false,
          boolean2: false,
          has_logic: false,
          date_time: "date & time",
          child_variables: [],
          logic_variables: [],
          logic_group: [
            {
              logic_set: [
                {
                  q_index: "",
                  logic_operator_id: "",
                  logic_input: "",
                  logic_condition: "",
                  logic_input_ui_type: "",
                  logic_operator: [],
                },
              ],
            },
          ],
          options: [
            {
              title: "option1",
              value: 1,
            },
          ],
          options_bangla: [
            {
              title: "অপশন১",
              value: 1,
            },
          ],

          images: [
            {
              url: "",
              id: "",
              value: 1,
              name: "",
              error_message: "",
            },
          ],
          option_values: {
            min: "",
            max: "",
            interval: "",
          },
          contactInfo: {
            first_name: true,
            middle_name: true,
            last_name: false,
            phone: true,
            email: true,
            address: false,
          },
          openEnded: {
            text_type: "",
            condition: "",
            conditional_number: "",
            conditional_text: "",
            custom_error: "",
          },
        },
      ],
      preQuestions: [],
      teamToProjectData: [],
      filter_data: [],

      locationBased: [],
      filter_skip: false,
      available_dasher: null,
    },
    data: {
      project_id: null,
      questions: [],
      preQuestions: [],
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    q_validate: function () {
      this.blank_check();
      return "Question should not be blank";
    },

    isDataLoaded: function () {
      this.loadData();
      if (this.indexData.projectData) {
        return true;
      } else {
        return false;
      }
    },

    check_submit: function () {
      if (this.q_blank_status == true) {
        return "contains error";
      } else {
        return "SUBMIT";
      }
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    // initialize editing data
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.data.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },
    hasValidation(question) {
      return (
        question.option_validating_parameter != null ||
        question.number_validating_parameter != null ||
        question.file_validating_parameter != null ||
        question.image_validating_parameter != null
      );
    },
    loadData() {
      if (this.indexData.projectData) {
        if (this.indexData.projectData.dasher_category_id == 2) {
          this.editedItem.teamToProjectData = JSON.parse(
            this.indexData.projectData.assigned_team_to_project
          );
        }

        this.editedItem.projectInfo.project_type_id =
          this.indexData.projectData.project_type_id;
        this.editedItem.projectData = this.indexData.projectData;
        this.editedItem.filter_skip = this.indexData.projectData.filter_skip;
        if (
          this.editedItem.projectInfo.project_type_id == 1 &&
          this.editedItem.filter_skip != 1
        ) {
          var filteringData = JSON.parse(
            this.indexData.projectData.filtering_parameters
          );
          this.ProjectFilterBasicData.ProjectFilteringParameter =
            this.indexData.ProjectFilteringParameter;
          this.ProjectFilterBasicData.districts = this.indexData.districts;
          this.ProjectFilterBasicData.divisions = this.indexData.divisions;
          this.ProjectFilterBasicData.educations = this.indexData.educations;
          this.ProjectFilterBasicData.genders = this.indexData.genders;
          this.ProjectFilterBasicData.income = this.indexData.income;
          this.ProjectFilterBasicData.operators = this.indexData.operators;
          this.ProjectFilterBasicData.professions = this.indexData.professions;
          this.ProjectFilterBasicData.upazila = this.indexData.upazila;
          this.editedItem.filter_data = filteringData;
        }

        var questionData = JSON.parse(
          this.indexData.projectData.project_question_json
        );
        var preQuestionData = JSON.parse(
          this.indexData.projectData.pre_survey_question_json
        );
        this.editedItem.questions = questionData.questions;
        if (this.indexData.projectData.has_pre_survey) {
          this.editedItem.preQuestions = preQuestionData.questions;
        }

        // console.log(this.editedItem.questions);
        this.teams = this.indexData.teams;
        this.uiCategory = this.indexData.uiCategory;

        // console.log( this.editedItem);
        return true;
      }
      return false;
    },
    blank_check() {
      return (this.q_blank_status = true);
    },

    getProjectLanguage(project_language) {
      if (project_language == 1) {
        return "English";
      } else if (project_language == 2) {
        return "Bangla";
      } else {
        return "English & Bangla both";
      }
    },
    back() {
      if (this.editedItem.projectData.project_type_id != 2) {
        router.push("/budget");
      } else {
        router.push("/budget2");
      }
    },

    submit() {
      if (
        this.editedItem.projectInfo.project_type_id == 2 &&
        this.indexData.numberOfResponse < 1
      ) {
        alert("Sorry! Survey locations could not be empty");
      } else {
        this.data.questions = this.editedItem.questions;
        this.data.preQuestions = this.editedItem.preQuestions;
        // this.data.project_id = 0;
        this.$store.dispatch("projectSubmission", [
          "project-submit",
          this.data,
        ]);
      }
      this.clicked = true;
    },
  },
};
</script>

<style scoped>
.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
  border-radius: 0;
  min-height: 100px;
}
.ck-content {
  min-height: 100px;
}
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
